/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Cta_PInputs */

const es_exp_mk_cta_p = /** @type {(inputs: Exp_Mk_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca experiencias, apúntate, sal a navegar y conoce gente nueva.`)
};

const gl_exp_mk_cta_p = /** @type {(inputs: Exp_Mk_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca experiencias, apúntate, sae a navegar e coñece xente nova.`)
};

const en_exp_mk_cta_p = /** @type {(inputs: Exp_Mk_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find experiences, sign up, get out on the water and meet new people.`)
};

/**
* | output |
* | --- |
* | "Find experiences, sign up, get out on the water and meet new people." |
*
* @param {Exp_Mk_Cta_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_cta_p = /** @type {((inputs?: Exp_Mk_Cta_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Cta_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_cta_p(inputs)
	if (locale === "en") return en_exp_mk_cta_p(inputs)
	return es_exp_mk_cta_p(inputs)
});